import React, { memo } from 'react'
import { Grid, Stack } from '@mui/material'
import { faCoins } from '@fortawesome/pro-light-svg-icons'

import BaseCard from '../shared/baseCard/BaseCard'
import Text from '../shared/text/Text'
import DefaultText from '../shared/text/DefaultText'
import QBXBanner from './QBXBanner'
import DisplayStats from './DisplayStats'
import {
  formatCurrencyValue,
  percentageOfCompletion
} from '../../util/numbers.helpers'
import CustomButton from '../shared/buttons/CustomButton'
import MilestoneProgress from '../shared/progressBar/MilestoneProgress'
import {
  CURRENCIES,
  DISABLE_CLAIM,
  MAX_PERCENTAGE,
  QUEST_TAP_POOL_ID
} from '../../constants/app'
import { formatCurrency, formatCurrencyShort } from '../../util/numbers.helpers'
import { buildCurrencyByChoice } from '../../util/claim.helpers'
import { removeNumbersFromString } from '../../util/string.helpers'
import { isCustomVestingFlow } from '../../util/app.helpers'

const ClaimCard = ({
  t,
  id,
  total,
  claimed,
  choice,
  available,
  onClickClaim
}) => {
  const unlocked = claimed + available
  const locked = total - unlocked
  const unlockedPercentage = formatCurrencyValue((unlocked / total) * 100, 1)
  const isCustomFlow = isCustomVestingFlow(id)
  const currency =
    id === QUEST_TAP_POOL_ID ? buildCurrencyByChoice(choice) : CURRENCIES.QBX
  const saleData = [
    {
      label: t('home.your-allocation'),
      value: formatCurrencyShort(total),
      helpText: formatCurrency(total)
    },
    {
      label: t('home.your-claimed', { currency }),
      value: formatCurrencyShort(claimed),
      helpText: formatCurrency(claimed)
    },
    {
      label: t('home.your-locked'),
      value: formatCurrencyShort(locked),
      helpText: formatCurrency(locked)
    },
    {
      label: t('home.available-to-claim', { currency }),
      value: formatCurrencyShort(available),
      helpText: formatCurrency(available),
      isPrimary: true
    }
  ]
  const slug = removeNumbersFromString(id)
  return (
    <BaseCard>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Text
                variant='h2'
                label={t(`home.claims-data.${slug}.name`)}
                fontWeight={700}
              />
              <DefaultText
                label={t('home.view-your-allocation', { currency })}
                color='text.primary'
                sx={{ fontSize: 18, mb: 3 }}
              />
              <DisplayStats data={saleData} isDescLarge />
            </Grid>
            <Grid item xs={12}>
              <Stack spacing={2}>
                <Text
                  variant='h4'
                  label={t('home.your-vesting-schedule')}
                  fontWeight={700}
                />
                <DefaultText
                  label={t(`home.claims-data.${slug}.terms`)}
                  sx={{ fontSize: 18 }}
                />
                <MilestoneProgress
                  end={t('home.unlocked', { value: unlockedPercentage })}
                  start={t('home.locked', {
                    value: formatCurrencyValue(
                      MAX_PERCENTAGE - unlockedPercentage,
                      1
                    )
                  })}
                  completed={percentageOfCompletion(
                    unlockedPercentage,
                    MAX_PERCENTAGE
                  )}
                />
              </Stack>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={4} sx={{ pt: '0 !important' }}>
          <QBXBanner>
            <CustomButton
              onClick={onClickClaim}
              icon={faCoins}
              label={isCustomFlow ? t('home.claim-reward') : t('home.claim')}
              disabled={!(available > 0) || DISABLE_CLAIM}
            />
          </QBXBanner>
        </Grid>
      </Grid>
    </BaseCard>
  )
}

export default memo(ClaimCard)
